import React from "react";
import { Button, Modal, Form, Radio, Input } from "antd";
import { useState, useEffect } from "react";
import InputMask from "react-input-mask";
import "./styles.scss";

export default function ModalSendLink({ info, sendLink, dataPreloaded }) {
  const [mode, setMode] = useState();
  const [form] = Form.useForm();

  const onChange = ({ target }) => {
    const { value } = target;
    setMode(value);
    form.resetFields();
  };

  const send = async () => {
    try {
      await form.validateFields();
    } catch (e) {
      return;
    }

    const { field } = form.getFieldValue();
    sendLink(mode, field);
    setMode(null);
  };

  useEffect(() => {
    const { contactPhone, contactEmail } = dataPreloaded ?? {};
    if (contactPhone || contactEmail) mode === "email" ? form.setFieldsValue({ field: contactEmail }) : form.setFieldsValue({ field: contactPhone });
  }, [mode]);

  return (
    info && (
      <Modal visible={info.visible} footer={null} closable={false} maskClosable={false} wrapClassName="modal-custom-info modal-custom-alert">
        <div className="modal-custom-info-content">
          <h1 style={{ lineHeight: "1", marginBottom: "15px", fontSize:'25px' }}>Elige la opción en donde quieres recibir la liga</h1>

          <Form form={form} style={{ width: "100%" }}>
            <Form.Item>
              <Radio.Group onChange={onChange} style={{ margin: "0 20px" }} value={mode}>
                <Radio value="sms">SMS</Radio>
                <Radio value="email">Email</Radio>
              </Radio.Group>
            </Form.Item>

            {mode === "email" && (
              <Form.Item
                label="Ingresa tu correo"
                name="field"
                rules={[
                  {
                    required: true,
                    message: "Campo obligatorio",
                  },
                  {
                    type: "email",
                    message: "Correo no válido",
                  },
                ]}
              >
                <Input data-testid="text-input" style={{ height: "auto", fontSize: "20px" }} autoComplete="off" />
              </Form.Item>
            )}

            {mode === "sms" && (
              <Form.Item
                label="Ingresa tu número telefónico"
                name="field"
                rules={[
                  {
                    required: true,
                    message: "Campo obligatorio",
                  },
                  {
                    message: "Número telefónico no válido",
                    validator: (_, val) => {
                      const regex = new RegExp("[_ ]", "ig");
                      let value = val.replace(regex, "");
                      const isValid =
                        RegExp("^(?!.*?(([1234567890])|((01234|12345|345678|45678|56789|67890|789012|23456)\\4{0,}))\\2{4,})[0-9]*$").test(value) &&
                        value.length === 10;
                      if (isValid) {
                        return Promise.resolve();
                      } else {
                        return Promise.reject();
                      }
                    },
                  },
                ]}
              >
                <InputMask
                  style={{ height: "auto", fontSize: "20px" }}
                  className="ant-input"
                  mask="99 9999 9999"
                  placeholder="00 0000 0000"
                ></InputMask>
              </Form.Item>
            )}

            <div className="buttons">
              <div
                className="cancel"
                onClick={() => {
                  setMode(null);
                  info.onCancel();
                }}
              >
                Cancelar
              </div>
              <Button
                className="ant-btn-outline c-2 ant-btn-size-xs"
                onClick={() => {
                  if (!mode) return;
                  send();
                }}
              >
                Enviar
              </Button>
            </div>
          </Form>
        </div>
      </Modal>
    )
  );
}
